import { render } from "./ProfileForm.vue?vue&type=template&id=0932f4a1"
import script from "./ProfileForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ProfileForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script